import _ from 'lodash';
import {
  RECEIVE_USER_TASKS,
  RECEIVE_SPECIFIC_USER_TASKS,
  APPEND_HIDDEN_UID,
  REMOVE_HIDDEN_UID,
  RESTORE_HIDDEN_UIDS
} from '../constants/actionTypes';

import objectAssign from 'object-assign';
import initialState from './initialState';

export default function userTask(state = initialState.userTask, action) {
  switch (action.type) {
    case RECEIVE_USER_TASKS:
      return objectAssign({}, state, {
        users: action.users
      });
    case RECEIVE_SPECIFIC_USER_TASKS: {
      const idx = _.findIndex(state.users, (user) => {
        return user.uid === action.uid;
      });
      return objectAssign({}, state, {
        users: [
          ...state.users.slice(0, idx),
          action.user,
          ...state.users.slice(idx + 1)
        ]
      });
    }
    case APPEND_HIDDEN_UID:
      return objectAssign({}, state, {
        hiddenUids: [
          ...state.hiddenUids,
          action.uid
        ]
      });
    case REMOVE_HIDDEN_UID: {
      const idx = _.indexOf(state.hiddenUids, action.uid);
      return objectAssign({}, state, {
        hiddenUids: [
          ...state.hiddenUids.slice(0, idx),
          ...state.hiddenUids.slice(idx + 1)
        ]
      });
    }
    case RESTORE_HIDDEN_UIDS:
      return objectAssign({}, state, {
        hiddenUids: [
          ...action.uids
        ]
      });
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/userTask.js
 **/